import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { isEmpty } from 'lodash-es';
import {
  Body1,
  Heading4,
  DoconCollapse,
} from '@docon/docon-ui-library';
import Layout, { MainBody } from 'components/Layout';
import HeaderBar from 'components/Layout/HeaderNavBar';
import { getFaqs } from 'redux/reducer/app';
import { Loader } from 'shared';
import { colors } from 'utilities/colorConfig';

const Heading = styled(Heading4)`
  padding: 18px 26px 16px;
  font-weight: 600;
  background: #F4F4F4;
`;

const Root = styled(Layout)`
  position: relative;

  ${MainBody} { padding-top: 0; }

  ${DoconCollapse} { background-color: ${colors.white} }

  ${() => isMobileOnly && css`
    ${MainBody} { padding: 0; }
  `}
`;

function HelpComponent() {
  const {
    faqs, isFetchingFaqs,
  } = useSelector(state => state.app);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isEmpty(faqs))
      dispatch(getFaqs('patientapp'));
  }, []);

  return (
    <Root
      hideFooter={isMobileOnly}
      header={isMobileOnly ? <HeaderBar /> : null}
    >
      {
        isFetchingFaqs ? <Loader /> : (
          <>
            <HeaderBar hidden={isMobileOnly} />
            <Heading title={'FAQ’s - Frequently Asked Questions'} />
            {
              faqs.map((faq: any) => (
                <DoconCollapse key={faq.id} title={faq.question.title} p='12px 26px'>
                  <Body1 py='5px' title={faq.answer.body} />
                </DoconCollapse>
              ))
            }
          </>
        )
      }
    </Root>
  );
}

export default HelpComponent;